import AnimateIn from './AnimateIn';
import classNames from 'classnames';
import SecondaryLink from './SecondaryLink';

const LinkButton = ({ component, className }) => {
  return (
    <AnimateIn className={classNames('link-button', className)}>
      <SecondaryLink title={component.title} url={component.url} />
    </AnimateIn>
  );
};

export default LinkButton;
